import { render } from "./MonthlyReports.vue?vue&type=template&id=3804e269&scoped=true"
import script from "./MonthlyReports.vue?vue&type=script&lang=js"
export * from "./MonthlyReports.vue?vue&type=script&lang=js"

import "./MonthlyReports.vue?vue&type=style&index=0&id=3804e269&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3804e269"]])

export default __exports__